import {View, useWindowDimensions} from 'react-native-web';
import { CardDetail } from '../../element/Card';
import Information from './Detail_event_Component/InformationEvent';
import Description from './Detail_event_Component/DescriptionEvent';
import { useState } from 'react';


const DetailEvent1 = ({navigation, route })=> {

const {item}=route.params
const [change, setChange]=useState(false)
const windows=useWindowDimensions()





 return(
        <View style={{alignItems:'center', justifyContent:'center', paddingTop:20}}>
         <CardDetail onPress={()=>{navigation.navigate('Home')}} onPress1={()=>{setChange(!change)}} icon1={true} icon2={true} hsize={0.95} bottom={15} right={15} marginTop={15}>
         {change? <Description item={item}/>:<Information item={item}/>}
         </CardDetail>
         </View>);}
 export default DetailEvent1